module.exports = __webpack_public_path__ + "static/media/frighteningPotential.893fb129.jpg";